/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Social_DescriptionInputs */

const et_service_social_description = /** @type {(inputs: Service_Social_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasva sotsiaalmeediast. Haldame sinu kontosid, loome sisu ja kasvatame sinu sarja teie sihtaudiensite.`)
};

const en_service_social_description = /** @type {(inputs: Service_Social_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grow from social media. We manage your accounts, create content, and expand your reach to your target audience.`)
};

/**
* | output |
* | --- |
* | "Grow from social media. We manage your accounts, create content, and expand your reach to your target audience." |
*
* @param {Service_Social_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const service_social_description = /** @type {((inputs?: Service_Social_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Social_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_service_social_description(inputs)
	return en_service_social_description(inputs)
});